import { render, staticRenderFns } from "./Levelbar.vue?vue&type=template&id=1bfa850a"
import script from "./Levelbar.vue?vue&type=script&lang=js"
export * from "./Levelbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports